import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Observable, of, Subscription } from 'rxjs';
import { defined, Store } from "@softline/core";
import {
  BackNavigable,
  BackNavigationService,
  Command,
  CommandStore,
  Scan,
  ScannerStore,
  SOFTLINE_FEATURE_COMMANDS,
  SOFTLINE_FEATURE_SCANNER,
  SOFTLINE_FEATURE_TITLE,
  TitleStore,
} from '@softline/application';
import { skip } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SOFTLINE_FEATURE_UPLOAD_ARCHIVE_VOUCHER } from '../../archivbeleg-upload.shared';
import { UploadArchiveVoucherStore } from '../../store/voucher.store';
import {
  MessageBarStore,
  SOFTLINE_FEATURE_MESSAGE_BAR,
  UiCoreModule,
} from '@softline/ui-core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'lib-gesamtabfrage-query',
    templateUrl: './find-voucher.component.html',
    styleUrls: ['./find-voucher.component.scss'],
    imports: [CommonModule, UiCoreModule]
})
export class FindVoucherComponent implements OnInit, OnDestroy, BackNavigable {
  private subscription?: Subscription;
  loading$ = this.store.observe(
    SOFTLINE_FEATURE_UPLOAD_ARCHIVE_VOUCHER,
    UploadArchiveVoucherStore.getters.loading
  );

  @Input() value?: string | null;

  constructor(
    private store: Store,
    protected router: Router,
    private backNavigationService: BackNavigationService
  ) {}

  ngOnInit(): void {
    this.backNavigationService.set(this);
    this.store.commit(
      SOFTLINE_FEATURE_COMMANDS,
      CommandStore.mutations.addSet,
      {
        name: FindVoucherComponent,
        commands: this.createCommands(),
      }
    );
    this.store.commit(
      SOFTLINE_FEATURE_TITLE,
      TitleStore.mutations.setTitle,
      '#UPLOAD_ARCHIVE_VOUCHER.FIND_VOUCHER.TITLE'
    );
    this.subscription = this.store
      .observe(SOFTLINE_FEATURE_SCANNER, ScannerStore.getters.latest)
      .pipe(skip(1))
      .subscribe(async (scan) => {
        if(scan)
          await this.validateScan(scan);
      });
  }

  ngOnDestroy() {
    if (this.subscription && !this.subscription.closed)
      this.subscription.unsubscribe();
    this.subscription = undefined;
    this.backNavigationService.set(undefined);
    this.store.commit(
      SOFTLINE_FEATURE_TITLE,
      TitleStore.mutations.setTitle,
      ''
    );
    this.store.commit(
      SOFTLINE_FEATURE_TITLE,
      TitleStore.mutations.setSubTitle,
      ''
    );
    this.store.commit(
      SOFTLINE_FEATURE_COMMANDS,
      CommandStore.mutations.removeSet,
      FindVoucherComponent
    );
  }

  protected createCommands(): Command[] {
    return [
      {
        icon: 'fa-regular fa-file-arrow-up',
        name: '#UPLOAD_ARCHIVE_VOUCHER.UPLOAD_PICTURE.TITLE',
        class: 'menu main-menu main-menu-top',
        routerLink: ['/archivbeleg'],
      },
    ];
  }

  async navigateBack(): Promise<void> {
    this.router.navigate(['/']);
  }

  async onSubmit(): Promise<void> {
    await this.validateScan({
      data: this.value ?? '',
      labelType: 'code39',
      timestamp: '',
    });
  }

  async startScan(): Promise<void> {
    await this.store.dispatch(
      SOFTLINE_FEATURE_SCANNER,
      ScannerStore.actions.scan,
      { labelType: ['code39', 'ean128'] }
    );
  }

  async validateScan(scan: Scan): Promise<void> {
    switch (scan.labelType) {
      case 'code39':
      case 'ean128':
        const result = await this.store.dispatch(
          SOFTLINE_FEATURE_UPLOAD_ARCHIVE_VOUCHER,
          UploadArchiveVoucherStore.actions.load,
          { pathParams: { ...scan } }
        );
        if (!result)
          await this.store.dispatch(
            SOFTLINE_FEATURE_MESSAGE_BAR,
            MessageBarStore.actions.error,
            '#UPLOAD_ARCHIVE_VOUCHER.MESSAGES.NO_VOUCHER_FOUND'
          );
        else await this.router.navigate(['/archivbeleg', 'upload']);
        break;
    }
  }
}
